import React from 'react'
import { connect } from 'react-redux'
import { getIsCurrentQuestionLastInSurvey } from '../selectors.js'
import DriverList from './DriverList.js'
import Question from './Question.js'
import OptionGroupQuestionContainer from './OptionGroupQuestionContainer.js'
import NextQuestionButton from './NextQuestionButton.js'
import LastQuestionButtons from './LastQuestionButtons.js'
import SelectedAnswerText from './SelectedAnswerText.js'
import CommentField from './CommentField.js'
import './QuestionLayout.css'

const QuestionLayout = ({ isLastQuestion }) => {
  const Buttons = isLastQuestion ? (
    <LastQuestionButtons />
  ) : (
    <NextQuestionButton />
  )

  return (
    <div className="QuestionLayout">
      <div className="segment noselect">
        <DriverList />
      </div>

      <div className="segment noselect">
        <Question />
      </div>

      <div className="segment noselect">
        <OptionGroupQuestionContainer />
      </div>

      <div className="full segment noselect">
        <SelectedAnswerText />
        <CommentField />
      </div>

      <div className="segment noselect button-footer">{Buttons}</div>
    </div>
  )
}

const mapStateToProps = state => ({
  isLastQuestion: getIsCurrentQuestionLastInSurvey(state),
})

export default connect(mapStateToProps)(QuestionLayout)



// WEBPACK FOOTER //
// ./src/components/QuestionLayout.js